/**
 * AiTyping — индикатор обработки запроса AI.
 *
 *  ВАЖНО: контейнер обёрнут в <div id="ai-waiting-anim" />.
 *  Точка расширения: можно вручную заменить содержимое этого div на Lottie/SVG,
 *  не трогая остальное приложение. По умолчанию там — task-steps loader
 *  (AiThinking) с автопрогрессом placeholder'а или реальными шагами по tool_use.
 *
 *  По умолчанию используется placeholder с 4 фиксированными шагами.
 *  Для реальных шагов (привязка к tool_use событиям) — передавать `steps`.
 */

import { AiThinking, type AiThinkingStep } from './AiThinking';
import { PulseAvatar } from './PulseAvatar';

export interface AiTypingProps {
  /** Реальные шаги от стрима (мап через aiToolLabels.toolCallsToSteps). */
  steps?: AiThinkingStep[];
  /** Не показывать avatar-кружок (для использования внутри bubble). */
  inline?: boolean;
}

export function AiTyping({ steps, inline = false }: AiTypingProps) {
  return (
    <div
      className="row gap12"
      style={{ alignItems: 'flex-start', padding: inline ? 0 : '8px 0' }}
      aria-live="polite"
      aria-busy="true"
    >
      {!inline && <PulseAvatar size={28} />}
      <div
        // Точка расширения: id="ai-waiting-anim"
        // Можно заменить содержимое (внутреннюю разметку) этого div на Lottie/SVG.
        // По умолчанию — task-steps loader (AiThinking).
        id="ai-waiting-anim"
        style={{ flex: 1, minWidth: 0, paddingTop: inline ? 0 : 2 }}
      >
        <AiThinking steps={steps} />
      </div>
    </div>
  );
}
